// web/src/lib/stripeConnect.ts — one place to start Stripe's embedded Connect components (portal spec 16).
// The publishable key is a build variable (VITE_STRIPE_PUBLISHABLE_KEY, not a secret). The appearance follows the
// dashboard theme: colours are read from the live CSS tokens when the instance starts, so dark mode stays readable.
import { loadConnectAndInitialize } from '@stripe/connect-js';
import { api } from './api';

export const STRIPE_PK = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string | undefined;
export type ConnectInstance = ReturnType<typeof loadConnectAndInitialize>;

const token = (name: string, fallback: string): string => {
  if (typeof document === 'undefined') return fallback;
  const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return v || fallback;
};

export function connectInstance(): ConnectInstance {
  return loadConnectAndInitialize({
    publishableKey: STRIPE_PK!,
    fetchClientSecret: async () => (await api.connectSession()).clientSecret,
    appearance: {
      variables: {
        colorPrimary: '#16a34a',
        fontSizeBase: '16px',
        colorBackground: token('--surface-1', '#ffffff'),
        colorText: token('--text', '#0f172a'),
        colorSecondaryText: token('--text-2', '#64748b'),
        colorBorder: token('--border', '#e2e8f0'),
      },
    },
  });
}
